export default "__VITE_ASSET__MJXdFrwX__"